module.exports = __webpack_public_path__ + "assets/img/ru-27a4ad99.png";